module.exports = __webpack_public_path__ + "static/media/bnr1.fd894b24.jpg";